import { Container } from "../Container/Container";
import { useEffect, useRef, useState } from "react";
import { NewsContainer, NewsTitle } from "../News/styled";
import { Link } from "react-router-dom";
import { New } from "../News/New/New";
import { useNews } from "../News/hook/useNews";
import { NewsBlock } from "./styled";
import { Pagination } from "../Pagination/Pagination";
import { Loader } from "../Loader/Loader";

export const NewsPage = () => {
  const [page, setPage] = useState(1);
  const { news, count, pageSize, isLoading } = useNews({ page });

  const pageSizeRef = useRef(0);
  if (pageSize && pageSize > pageSizeRef.current) {
    pageSizeRef.current = pageSize;
  }

  const effectivePageSize = pageSizeRef.current || pageSize || 1;
  const totalPages = count > 0 ? Math.ceil(count / effectivePageSize) : 1;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  if (isLoading && !news) return <Loader />;

  return (
    <Container>
      <NewsContainer>
        <NewsTitle>Новости школы</NewsTitle>
        <NewsBlock>
          {news &&
            news.map((value: any) => (
              <Link key={value.slug} to={`/news/${value.slug}`}>
                <New props={value} />
              </Link>
            ))}
        </NewsBlock>
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onChange={setPage}
        />
      </NewsContainer>
    </Container>
  );
};
